import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
} from '@mui/material';

const formatCurrency = (amount) => {
  if (amount == null) return 'SGD 0.00';
  return `SGD ${parseFloat(amount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};

const InsightTable = ({ data, periodLabel, threshold }) => {
  let p1Header = '-1 Day (Total Amount)';
  let p2Header = '-2 Day (Total Amount)';

  if (periodLabel === '7_days') {
    p1Header = '-1 to -7 days (Total Amount)';
    p2Header = '-8 to -14 days (Total Amount)';
  } else if (periodLabel === '30_days') {
    p1Header = '-1 to -30 days (Total Amount)';
    p2Header = '-31 to -60 days (Total Amount)';
  }

  const numericThreshold = parseFloat(threshold) || 0;

  return (
    <TableContainer component={Paper} variant="outlined" sx={{ mt: 3, mb: 3 }}>
      <Table aria-label="insight table">
        <TableHead>
          <TableRow>
            <TableCell><strong>Merchant</strong></TableCell>
            <TableCell align="right"><strong>{p1Header}</strong></TableCell>
            <TableCell align="right"><strong>{p2Header}</strong></TableCell>
            <TableCell align="right"><strong>% Change of Total Amount</strong></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.length === 0 ? (
            <TableRow>
              <TableCell colSpan={4} align="center">
                No monitored merchants data available.
              </TableCell>
            </TableRow>
          ) : (
            data.map((row) => {
              const changePercent = row.change_percent || 0;
              const isPositive = changePercent > 0;
              const isNegative = changePercent < 0;
              const absChange = Math.abs(changePercent);
              const passesThreshold = absChange >= numericThreshold;

              let color = 'inherit';
              if (passesThreshold) {
                if (isPositive) color = 'green';
                if (isNegative) color = 'red';
              }

              return (
                <TableRow key={row.merchant_id}>
                  <TableCell component="th" scope="row">
                    {row.merchant_name ? `${row.merchant_name} (${row.merchant_id})` : row.merchant_id}
                  </TableCell>
                  <TableCell align="right">{formatCurrency(row.current_volume)}</TableCell>
                  <TableCell align="right">{formatCurrency(row.previous_volume)}</TableCell>
                  <TableCell align="right">
                    <Typography style={{ color, fontWeight: passesThreshold ? 'bold' : 'normal' }}>
                      {isPositive ? '+' : ''}{changePercent.toFixed(2)}%
                    </Typography>
                  </TableCell>
                </TableRow>
              );
            })
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default InsightTable;
